import {
  ArrowForward,
  AutoAwesome,
  Business,
  CheckCircle,
  CloudDone,
  Delete,
  East,
  Edit,
  Fingerprint,
  Handshake,
  Lightbulb,
  People,
  PlayArrow,
  Security,
  Speed,
  TrendingUp,
  VerifiedUser
} from '@mui/icons-material';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Container,
  Divider,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import React from 'react';

const AboutPage = () => {
  const stats = [
    { label: 'Yıllık Deneyim', value: '15+', icon: <Business />, color: '#635bff' },
    { label: 'Mutlu Müşteri', value: '10,000+', icon: <People />, color: '#00d4aa' },
    { label: 'İşlenen Belge', value: '1M+', icon: <TrendingUp />, color: '#ff5722' },
    { label: 'Başarılı Proje', value: '500+', icon: <Edit />, color: '#9c27b0' },
  ];

  const values = [
    {
      icon: <Security />,
      title: 'Güvenlik',
      description: 'ISO 27001 sertifikalı güvenlik standartları ile verilerinizi koruyoruz.',
      color: '#635bff',
    },
    {
      icon: <Lightbulb />,
      title: 'İnovasyon',
      description: 'Yapay zeka ve modern teknolojilerle sürekli gelişim sağlıyoruz.',
      color: '#00d4aa',
    },
    {
      icon: <Handshake />,
      title: 'Güvenilirlik',
      description: 'Müşterilerimizle uzun vadeli ve güven temelli ilişkiler kuruyoruz.',
      color: '#ff5722',
    },
    {
      icon: <Speed />,
      title: 'Verimlilik',
      description: 'Optimize edilmiş süreçlerle hızlı ve etkili çözümler üretiyoruz.',
      color: '#9c27b0',
    },
  ];

  const timeline = [
    {
      year: '2010',
      title: 'Kuruluş',
      description: 'Ronesis, belge yönetimi alanında uzman kadrosuyla kuruldu.',
      color: '#635bff',
    },
    {
      year: '2015',
      title: 'İlk EBYS Çözümü',
      description: 'İlk elektronik belge yönetim sistemi geliştirildi ve piyasaya sunuldu.',
      color: '#00d4aa',
    },
    {
      year: '2018',
      title: 'KEP Entegrasyonu',
      description: 'KEP (Kayıtlı Elektronik Posta) entegrasyonu ile resmi yazışmalar başladı.',
      color: '#ff5722',
    },
    {
      year: '2020',
      title: 'EYP Desteği',
      description: 'Elektronik Yazışma Paketi desteği ile mevzuata tam uyum sağlandı.',
      color: '#9c27b0',
    },
    {
      year: '2022',
      title: 'E-İmza Entegrasyonu',
      description: 'TürkTrust ile entegre e-imza çözümleri devreye alındı.',
      color: '#635bff',
    },
    {
      year: '2024',
      title: 'Yapay Zeka Asistanı',
      description: 'AI destekli yazışma asistanı ile otomatik metin oluşturma özelliği eklendi.',
      color: '#00d4aa',
    },
  ];

  const team = [
    {
      name: 'Ahmet Yılmaz',
      position: 'Genel Müdür & Kurucu',
      description: '20 yıllık IT deneyimi ile Ronesis\'i yönetiyor. Bilgisayar Mühendisliği mezunu.',
      skills: ['Liderlik', 'Strateji', 'İş Geliştirme', 'Teknoloji Yönetimi'],
      avatar: 'AY',
      color: '#635bff',
    },
    {
      name: 'Dr. Ayşe Demir',
      position: 'CTO & Kurucu',
      description: 'Yazılım geliştirme ve sistem mimarisi konularında uzman. Doktora dereceli.',
      skills: ['Yazılım Mimarisi', 'AI/ML', 'Sistem Tasarımı', 'R&D'],
      avatar: 'AD',
      color: '#00d4aa',
    },
    {
      name: 'Mehmet Kaya',
      position: 'Satış ve Pazarlama Müdürü',
      description: 'B2B satış ve müşteri ilişkileri konularında 15 yıllık deneyime sahip.',
      skills: ['Satış Yönetimi', 'Müşteri İlişkileri', 'Pazarlama', 'İş Geliştirme'],
      avatar: 'MK',
      color: '#ff5722',
    },
    {
      name: 'Fatma Özkan',
      position: 'Teknik Destek Müdürü',
      description: 'Müşteri destek süreçleri ve teknik eğitimler konusunda uzman.',
      skills: ['Teknik Destek', 'Eğitim', 'Müşteri Hizmetleri', 'Süreç Yönetimi'],
      avatar: 'FÖ',
      color: '#9c27b0',
    },
  ];

  const technologies = [
    { name: 'KEP Entegrasyonu', value: 100, icon: <Security />, color: '#635bff' },
    { name: 'EYP Desteği', value: 100, icon: <Delete />, color: '#00d4aa' },
    { name: 'E-İmza Entegrasyonu', value: 100, icon: <Fingerprint />, color: '#ff5722' },
    { name: 'Yapay Zeka', value: 95, icon: <AutoAwesome />, color: '#9c27b0' },
    { name: 'Bulut Teknolojileri', value: 98, icon: <CloudDone />, color: '#635bff' },
    { name: 'Sistem Entegrasyonu', value: 96, icon: <IntegrationInstructionsIcon />, color: '#00d4aa' },
  ];

  const certifications = [
    'ISO 27001 Bilgi Güvenliği',
    'KVKK Uyumluluk Sertifikası',
    'TürkTrust Entegrasyon Partneri',
    'Microsoft Gold Partner',
    'AWS Solution Provider',
    'Türk Standartları Enstitüsü Onaylı'
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(150deg, #635bff 15%, #8b9cf7 70%, #c7d2fe 94%)',
          pt: { xs: 6, md: 8 },
          pb: { xs: 12, md: 20 },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', maxWidth: '900px', mx: 'auto' }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '48px', md: '80px' },
                fontWeight: 600,
                color: 'white',
                lineHeight: { xs: '56px', md: '88px' },
                mb: 3,
                letterSpacing: '-0.025em',
              }}
            >
              Hakkımızda
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.9)',
                fontWeight: 400,
                lineHeight: 1.6,
                mb: 6,
                fontSize: { xs: '20px', md: '24px' },
                maxWidth: '600px',
                mx: 'auto',
              }}
            >
              15 yıllık deneyimimiz ve uzman kadromuzla, Türkiye'nin en güvenilir
              elektronik belge yönetim sistemi çözümlerini sunuyoruz.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
              sx={{ mb: 8 }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowForward />}
                sx={{
                  backgroundColor: 'white',
                  color: '#635bff',
                  px: 4,
                  py: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#f6f9fc',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                İletişime Geçin
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<PlayArrow />}
                sx={{
                  borderColor: 'rgba(255,255,255,0.4)',
                  color: 'white',
                  px: 4,
                  py: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'rgba(255,255,255,0.6)',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                  },
                }}
              >
                Şirket Videosu
              </Button>
            </Stack>

            {/* Stats */}
            <Grid container spacing={4}>
              {stats.map((stat, index) => (
                <Grid item xs={6} md={3} key={index}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { xs: '32px', md: '40px' },
                        fontWeight: 600,
                        color: 'white',
                        mb: 1,
                        lineHeight: 1,
                      }}
                    >
                      {stat.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255,255,255,0.8)',
                        fontSize: '14px',
                        fontWeight: 500,
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Mission & Vision */}
      <Box sx={{ py: { xs: 10, md: 16 }, backgroundColor: 'white' }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '32px', md: '48px' },
                  fontWeight: 600,
                  color: '#0a2540',
                  mb: 4,
                  letterSpacing: '-0.02em',
                  lineHeight: { xs: '40px', md: '56px' },
                }}
              >
                Misyonumuz
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#425466',
                  fontSize: '18px',
                  lineHeight: '28px',
                  mb: 4,
                }}
              >
                Türkiye'deki tüm kurum ve kuruluşların belge yönetim süreçlerini dijitalleştirmek,
                KEP, EYP ve yapay zeka teknolojileri ile modern, güvenli ve verimli çözümler sunmak.
                Müşterilerimizin iş süreçlerini optimize ederek rekabet avantajı sağlamalarına katkıda bulunmak.
              </Typography>
              <Button
                variant="outlined"
                size="large"
                endIcon={<East />}
                sx={{
                  borderColor: '#e3e8ee',
                  color: '#425466',
                  fontSize: '16px',
                  fontWeight: 500,
                  textTransform: 'none',
                  px: 3,
                  py: 1.5,
                  '&:hover': {
                    borderColor: '#635bff',
                    backgroundColor: '#635bff05',
                  },
                }}
              >
                Daha fazla bilgi
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  border: '1px solid #e3e8ee',
                  borderRadius: '12px',
                  p: 4,
                  backgroundColor: '#fafbfc',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: '28px', md: '32px' },
                    fontWeight: 600,
                    color: '#0a2540',
                    mb: 3,
                  }}
                >
                  Vizyonumuz
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#425466',
                    fontSize: '16px',
                    lineHeight: '24px',
                    mb: 3,
                  }}
                >
                  Elektronik belge yönetimi alanında Türkiye'nin lider şirketi olmak.
                  Uluslararası standartlarda hizmet vererek, dijital dönüşümün öncüsü konumunda
                  bulunmak ve sürdürülebilir teknoloji çözümleri ile toplumsal değer yaratmak.
                </Typography>
                <Stack spacing={2}>
                  {[
                    'Türkiye\'nin lider EBYS şirketi',
                    'Uluslararası standartlarda hizmet',
                    'Dijital dönüşümün öncüsü',
                    'Sürdürülebilir teknoloji çözümleri'
                  ].map((item, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <CheckCircle sx={{ color: '#635bff', fontSize: 20 }} />
                      <Typography variant="body2" sx={{ color: '#8792a2' }}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Values */}
      <Box sx={{ py: { xs: 10, md: 16 }, backgroundColor: '#fafbfc' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: { xs: 8, md: 12 } }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '32px', md: '48px' },
                fontWeight: 600,
                color: '#0a2540',
                mb: 4,
                letterSpacing: '-0.02em',
                lineHeight: { xs: '40px', md: '56px' },
              }}
            >
              Değerlerimiz
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#425466',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '32px',
                maxWidth: '600px',
                mx: 'auto',
              }}
            >
              Çalışma prensipleri ve kurumsal değerlerimiz
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {values.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    border: '1px solid #e3e8ee',
                    borderRadius: '12px',
                    p: 4,
                    textAlign: 'center',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: value.color,
                      transform: 'translateY(-4px)',
                      boxShadow: `0 8px 30px ${value.color}15`,
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      backgroundColor: `${value.color}15`,
                      color: value.color,
                      width: 64,
                      height: 64,
                      mx: 'auto',
                      mb: 3,
                    }}
                  >
                    {value.icon}
                  </Avatar>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#0a2540' }}>
                    {value.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#425466', lineHeight: 1.6 }}>
                    {value.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Timeline */}
      <Box sx={{ py: { xs: 10, md: 16 }, backgroundColor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: { xs: 8, md: 12 } }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '32px', md: '48px' },
                fontWeight: 600,
                color: '#0a2540',
                mb: 4,
                letterSpacing: '-0.02em',
                lineHeight: { xs: '40px', md: '56px' },
              }}
            >
              Tarihçemiz
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#425466',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '32px',
                maxWidth: '600px',
                mx: 'auto',
              }}
            >
              2010'dan günümüze gelişim hikayemiz
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {timeline.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    border: '1px solid #e3e8ee',
                    borderRadius: '12px',
                    p: 4,
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: item.color,
                      transform: 'translateY(-4px)',
                      boxShadow: `0 8px 30px ${item.color}15`,
                    },
                  }}
                >
                  <Chip
                    label={item.year}
                    sx={{
                      backgroundColor: item.color,
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  />
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#0a2540' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#425466', lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Technologies & Team */}
      <Box sx={{ py: { xs: 10, md: 16 }, backgroundColor: '#fafbfc' }}>
        <Container maxWidth="lg">
          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '28px', md: '32px' },
                  fontWeight: 600,
                  color: '#0a2540',
                  mb: 4,
                }}
              >
                Teknoloji Uzmanlığımız
              </Typography>
              <Stack spacing={3}>
                {technologies.map((tech, index) => (
                  <Box key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Avatar sx={{ width: 32, height: 32, mr: 2, backgroundColor: `${tech.color}15`, color: tech.color }}>
                        {tech.icon}
                      </Avatar>
                      <Typography variant="body1" sx={{ fontWeight: 500, flexGrow: 1, color: '#0a2540' }}>
                        {tech.name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#8792a2' }}>
                        {tech.value}%
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={tech.value}
                      sx={{
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: '#e3e8ee',
                        '& .MuiLinearProgress-bar': {
                          borderRadius: 3,
                          backgroundColor: tech.color,
                        },
                      }}
                    />
                  </Box>
                ))}
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '28px', md: '32px' },
                  fontWeight: 600,
                  color: '#0a2540',
                  mb: 4,
                }}
              >
                Sertifikalar ve Onaylar
              </Typography>
              <Paper sx={{ border: '1px solid #e3e8ee', borderRadius: '12px', p: 4 }}>
                <List sx={{ p: 0 }}>
                  {certifications.map((cert, index) => (
                    <React.Fragment key={index}>
                      <ListItem sx={{ px: 0, py: 2 }}>
                        <ListItemIcon>
                          <VerifiedUser sx={{ color: '#635bff' }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={cert}
                          sx={{ '& .MuiListItemText-primary': { fontWeight: 500, color: '#0a2540' } }}
                        />
                      </ListItem>
                      {index < certifications.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Team */}
      <Box sx={{ py: { xs: 10, md: 16 }, backgroundColor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: { xs: 8, md: 12 } }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '32px', md: '48px' },
                fontWeight: 600,
                color: '#0a2540',
                mb: 4,
                letterSpacing: '-0.02em',
                lineHeight: { xs: '40px', md: '56px' },
              }}
            >
              Yönetim Ekibimiz
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#425466',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '32px',
                maxWidth: '600px',
                mx: 'auto',
              }}
            >
              Deneyimli ve uzman kadromuz
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {team.map((member, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  sx={{
                    border: '1px solid #e3e8ee',
                    borderRadius: '12px',
                    p: 4,
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: member.color,
                      transform: 'translateY(-4px)',
                      boxShadow: `0 8px 30px ${member.color}15`,
                    },
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 3, mb: 3 }}>
                    <Avatar
                      sx={{
                        width: 64,
                        height: 64,
                        backgroundColor: member.color,
                        fontSize: '1.5rem',
                        fontWeight: 700,
                      }}
                    >
                      {member.avatar}
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#0a2540' }}>
                        {member.name}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ color: member.color, fontWeight: 500, mb: 2 }}
                      >
                        {member.position}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography variant="body2" sx={{ mb: 3, lineHeight: 1.6, color: '#425466' }}>
                    {member.description}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {member.skills.map((skill, idx) => (
                      <Chip
                        key={idx}
                        label={skill}
                        size="small"
                        sx={{
                          backgroundColor: `${member.color}15`,
                          color: member.color,
                          fontSize: '12px',
                          fontWeight: 500,
                        }}
                      />
                    ))}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          backgroundColor: '#0a2540',
          color: 'white',
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '32px', md: '48px' },
                fontWeight: 600,
                mb: 4,
                letterSpacing: '-0.02em',
                lineHeight: { xs: '40px', md: '56px' },
              }}
            >
              Ronesis Ailesine Katılın
            </Typography>
            <Typography
              variant="h6"
              sx={{
                opacity: 0.8,
                fontWeight: 400,
                mb: 6,
                fontSize: '20px',
                lineHeight: '32px',
                maxWidth: '500px',
                mx: 'auto',
              }}
            >
              15 yıllık deneyimimiz ve uzman kadromuzla, dijital dönüşüm yolculuğunuzda yanınızdayız.
              Güvenilir teknoloji partneri olarak, başarıya birlikte ulaşalım.
            </Typography>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
              sx={{ mb: 4 }}
            >
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#635bff',
                  color: 'white',
                  px: 4,
                  py: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#5a52e8',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                İletişime Geçin
              </Button>
              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'rgba(255,255,255,0.3)',
                  color: 'white',
                  px: 4,
                  py: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  borderRadius: '6px',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: 'rgba(255,255,255,0.5)',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                  },
                }}
              >
                Referanslarımızı Görün
              </Button>
            </Stack>
            <Typography
              variant="body2"
              sx={{
                opacity: 0.7,
                fontSize: '14px',
              }}
            >
              ✓ 15 yıllık deneyim  ✓ Uzman kadro  ✓ 7/24 destek  ✓ Güvenilir partner
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutPage;